
import HttpUtil from "@/assets/js/HttpUtil";
import { StoreTypes } from "@/assets/js/Types";
import Urls from "@/assets/js/Urls";
import setItem from "@/components/MenuSetItemCom.vue";
import project from "@/store/project";
import dialogCom from "@/components/ModelCom.vue";
import Vue from "vue";
import { RouterView } from "vue-router";
export default Vue.extend({
  components: { setItem, RouterView, dialogCom },
  data() {
    return {
      projectInfo: {
        logoPic: "" as string,
      } as any,
      logoPic: "" as string,
      actions: [
        {
          sid: "0",
          name: "修改密码",
        },
        {
          sid: "1",
          name: "安全退出",
        },
      ],
      iconAdmin: require("@/assets/img/icon/icon-admin.png"),
      userInfo: {
        displayName: "",
        isSuperUser: false,
        projectSid: "",
        userName: "",
        userSid: "",
      },
      title: "",
      modifyPassword: {
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      },
    };
  },
  mounted() {
    this.projectInfo = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
    this.userInfo = this.$store.state.project[StoreTypes.XC_USERINFO];
    this.logoPic = this.projectInfo.logoPic;

    this.getTitle();
  },
  watch: {
    $route(to, from) {
      this.getTitle();
    },
  },
  methods: {
    async modifyPasswordSubmit() {
      const form: any = this.$refs.form;
      var reslut = await form.validate();
      if (reslut) {
        if (this.modifyPassword.newPassword != this.modifyPassword.newPassword2) {
          throw "两次密码输入不一致";
        }
        await HttpUtil.XCHttpPost(Urls.ChangePassword, this.modifyPassword, true, false);
        this.closeUserDialog();
      }
    },
    closeUserDialog() {
      const userdialog: any = this.$refs.userdialog;
      userdialog.hiden();
    },
    async userClick(command: string) {
      if (command == "0") {
        const userdialog: any = this.$refs.userdialog;
        userdialog.show();
      } else {
        await HttpUtil.XCHttpPost(Urls.Logout, "", true, false);
        this.$router.push("/");
      }
    },
    getTitle() {
      const path: string = this.$route.path;
      const array: any[] = path.split("/");
      const newpath = `/${array[1]}/${array[2]}`;
      const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      if (project && project.menu) {
        if (project.menu.childrens && project.menu.childrens.length != 0) {
          const m: any = project.menu.childrens.find(
            (x: any) => x.path.toLowerCase() == newpath.toLowerCase()
          );
          if (m) {
            this.title = `首页/ ${m.menuName}`;
          } else {
            this.title = "";
          }
        }
      }
      var ms = project.menu.childrens.filter((item: any) => item.showInLine == 0);
      if (ms.length == 0 && project.smartName && project.smartName.length > 0) {
        window.location.reload();
      }
    },
  },
});
